import "../../src/Components/Publish/Temporal/styles.less";

import { Col, Row } from "antd";
import { PageLayout } from "../../src/Components/Layout/web";
import React from "react";
import {
	DoubtsSection,
	PaymentMethodSection,
	PricingCardSection,
	RentProperty,
	TableSection,
	YourPublication,
} from "../../src/Components/Publish/Temporal/components";
import { usePublishTemporal } from "../../src/Components/Publish/Temporal/hook";
import { useTheme } from "../../shared-components/Styles/ThemeHook";
import { withApollo } from "../../lib/apollo3";
import { withAuth } from "../../lib/auth";
import { withContext } from "../../lib/context";
import { withGlobalComponents } from "../../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../../shared-components/i18n";

// Publicar Alquiler Temporario
const PublicarAlquilerTemporario = () => {
	const { theme } = useTheme();
	const { cards, table } = usePublishTemporal();

	const scrollTo = (id: string) => {
		window.scroll(0, document.getElementById(id).offsetTop - theme.headerHeight);
	};

	const scrollToDoubts = () => {
		scrollTo("dudas");
	};
	const scrollToTable = () => {
		scrollTo("tabla");
	};

	const scrollToPricingCardsSection = () => {
		scrollTo("pricing-cards-section");
	};

	return (
		<PageLayout classContainer="publish-page">
			<Row>
				{/** Rent Property Section */}
				<Col span={24} className="rent-property">
					<div className="container">
						<RentProperty onClick={scrollToPricingCardsSection} />
					</div>
				</Col>

				{/** Your Publication Section */}
				<Col span={24} className="your-publication">
					<div className="container">
						<YourPublication />
					</div>
				</Col>

				{/** Pricing Card Section */}
				{cards.length > 0 && (
					<Col span={24} className="pricing-cards-section" id="pricing-cards-section">
						<div className="container">
							<PricingCardSection cards={cards} scrollToTable={scrollToTable} />
						</div>
					</Col>
				)}

				{/** Table Section */}
				{table && (
					<Col
						span={24}
						style={{ padding: `${theme.spacing.xxlSpacing}px 0` }}
						id={"tabla"}
						className="table-section">
						<div className="container">
							<TableSection table={table} />
						</div>
					</Col>
				)}

				{/** Payment Method Section */}
				<Col span={24} className={"payment-method"}>
					<div className="container">
						<PaymentMethodSection scrollToDoubts={scrollToDoubts} />
					</div>
				</Col>

				{/** Doubts Section */}
				<Col span={24} id="dudas" className={"doubts-section"}>
					<div className="container" style={{ height: "100%" }}>
						<DoubtsSection />
					</div>
				</Col>
			</Row>
		</PageLayout>
	);
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(PublicarAlquilerTemporario))), {
		withDummyContext: false,
		withFiltersContext: false,
		withConfigContext: true,
		withThemeContext: true,
	})
);
